<div class="mainFrame">
  <app-header></app-header>
  <pri-scrollbar class="mainFrame__body">
    <router-outlet></router-outlet>
  </pri-scrollbar>
  <app-footer></app-footer>
</div>
